import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';

function* getStorages(action) {
  try {
    const params = {
      query: {
        limit: 10000,
        name: action?.payload?.name ?? '',
      },
    };

    const { data } = yield call(request, API.BROWSE_STORAGES_BY_NAME, 'GET', params);

    yield put(actions.getStoragesSuccess(data));
  } catch (e) {
    yield put(actions.getStoragesError(e));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* getStoragesWatcher() {
  yield takeEvery(constants.GET_STORAGES, getStorages);
}
